var map = {
	"./en/article.md": "2419",
	"./en/contacts.md": "fbc4",
	"./en/journals.md": "83a8",
	"./en/journals/JBTA/about.md": "844c",
	"./en/journals/JBTA/editors.md": "4b42",
	"./en/journals/JBTA/ethics.md": "7b7f",
	"./en/journals/JBTA/index.md": "55ef",
	"./en/journals/JBTA/instructions.md": "aaac",
	"./en/journals/JBTA/peer.md": "fedf",
	"./en/journals/JBTA/subscription.md": "bfbb",
	"./en/journals/JEPE/about.md": "7d52",
	"./en/journals/JEPE/editors.md": "44ec",
	"./en/journals/JEPE/ethics.md": "8ab3",
	"./en/journals/JEPE/index.md": "7615",
	"./en/journals/JEPE/instructions.md": "9388",
	"./en/journals/JEPE/peer.md": "0e4a",
	"./en/journals/JEPE/subscription.md": "0598",
	"./en/journals/OXYCOM/about.md": "6eb1",
	"./en/journals/OXYCOM/editors.md": "578c",
	"./en/journals/OXYCOM/ethics.md": "77b2",
	"./en/journals/OXYCOM/index.md": "e880",
	"./en/journals/OXYCOM/instructions.md": "f43b",
	"./en/journals/OXYCOM/peer.md": "a72f",
	"./en/journals/OXYCOM/subscription.md": "edcf",
	"./en/journals/index.md": "cc41",
	"./en/journals/templates/subscription-request-confirmation.md": "6a5c",
	"./en/journals/templates/subscription-request-notification.md": "f2f9",
	"./en/login/index.md": "edfc",
	"./en/login/login.md": "ba09",
	"./en/login/reset-sent.md": "ffff",
	"./en/login/reset.md": "30e8",
	"./en/login/sign-up.md": "bc7b",
	"./en/news.md": "12c6",
	"./en/profile.md": "dcf1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d7b";